<app-main-pages-container>
    @if (isClosed) {
        <section class="inner_texts"><p>We are very sorry, but the English version of the site is closed.</p></section>
    } @else {
        <section class="inner_texts" [innerHTML]="'home_text' | translate"></section>
        <button mat-flat-button routerLink="login">{{ 'enter' | translate }}</button>
    }
</app-main-pages-container>